/**
 * InvitePage - Send invitation to Partner B
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Mail, CheckCircle, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';
import Header from '../components/shared/Header';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const InvitePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [invited, setInvited] = useState(false);

  const handleInvite = async () => {
    setLoading(true);
    try {
      const relationshipId = sessionStorage.getItem('relationship_id');
      const partnerEmail = sessionStorage.getItem('partner_email');

      await axios.post(`${API}/partners/invite`, {
        relationship_id: relationshipId,
        partner_email: partnerEmail
      });

      setInvited(true);
      toast.success('Invitation sent to your partner!');
    } catch (error) {
      console.error('Error inviting partner:', error);
      toast.error('Failed to send invitation');
      setLoading(false);
    }
  };

  const handleContinue = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex items-center justify-center p-6" style={{minHeight: 'calc(100vh - 100px)'}}>
        <div className="max-w-lg w-full bg-white rounded-2xl border border-stone-100 shadow-sm p-12 text-center">
          {!invited ? (
            <>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Mail className="w-8 h-8 text-blue-600" />
              </div>
              
              <h2 className="text-3xl font-bold text-stone-900 mb-4">Invite Your Partner</h2>
              
              <p className="text-stone-600 leading-relaxed mb-8">
                Your partner will receive a secure link to complete their portion privately. 
                Responses will remain hidden until both of you lock your answers.
              </p>

              <button
                onClick={handleInvite}
                disabled={loading}
                className="bg-mc-blue-deep text-white hover:bg-mc-blue-dark rounded-full px-8 py-4 text-lg font-medium transition-all hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 inline-flex items-center gap-2"
                data-testid="send-invitation"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    Sending...
                  </>
                ) : (
                  <>
                    Send Invitation
                    <Mail className="w-5 h-5" />
                  </>
                )}
              </button>
            </>
          ) : (
            <>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-8 h-8 text-mc-blue-deep" />
              </div>
              
              <h2 className="text-3xl font-bold text-stone-900 mb-4">Invitation Sent!</h2>
              
              <p className="text-stone-600 leading-relaxed mb-8">
                Your partner has been notified. You can now begin your individual reflection.
              </p>

              <button
                onClick={handleContinue}
                className="bg-mc-blue-deep text-white hover:bg-mc-blue-dark rounded-full px-8 py-4 text-lg font-medium transition-all hover:scale-[1.02] active:scale-[0.98] inline-flex items-center gap-2"
                data-testid="continue-to-dashboard"
              >
                Continue to Dashboard
                <ArrowRight className="w-5 h-5" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvitePage;
